import React, { useState, useContext, createContext, useEffect } from "react";
import { BestDishServices } from "../services/BestDishServices";
import { useClientCity } from "./useClientCity";
import { useLanguage } from "./useLanguage";

// ** Utils Imports
const bestDishesContext = createContext();

export function ProviderBestDishes({ children }) {
  const bestDishes = useProviderBestDishes();
  return (
    <bestDishesContext.Provider value={bestDishes}>
      {children}
    </bestDishesContext.Provider>
  );
}

export const useBestDishes = () => {
  return useContext(bestDishesContext);
};

function useProviderBestDishes() {
  const { language } = useLanguage();
  const {clientCity} = useClientCity()
  // ** State
  const [bestDishes, setBestDishes] = useState({
    items: [],
    loading: true,
    error: false
  });

  // ** Get best Dishes
  const getBestDishes = () => {
    setBestDishes((prev) => ({ ...prev, loading: true }));
    BestDishServices.getBestDish()
      .then((res) => {
        const { data } = res;
        if (Array.isArray(data?.data)) {
          setBestDishes((prev) => ({ ...prev, items: [...data?.data] }));
        }
      })
      .catch((error) => {
        setBestDishes((prev) => ({ ...prev, error: true }));
      })
      .finally(() => {
        setBestDishes((prev) => ({ ...prev, loading: false }));
      });
  };

  useEffect(() => {
    if (clientCity && Object.keys(clientCity).length > 0) {
      if (clientCity.id !== 0) {
        getBestDishes();
      }
    }
    return () => {};
  }, [language,clientCity]);

  // Return State
  return {
    bestDishes,
    getBestDishes
  };
}
